import { Stack } from '@mui/material';
import React from 'react';

const SurveyList = ({ children }) => {
  return (
    <React.Fragment>
      <Stack gap=".5em" mt="1em" p=".5em">
        {children}
      </Stack>
    </React.Fragment>
  );
};

export default SurveyList;
